import { Injectable } from '@angular/core';
import { UidRegisterServiceProxy, UidEntityDto, EnumUidStatus } from '@shared/service-proxies/service-proxies';
import { Observable } from 'rxjs/internal/Observable';

@Injectable()
export class UidService {

    constructor(
        private uidService: UidRegisterServiceProxy,
    ) {}

    public getUidEntityByUidNumber(uid: string): Observable<UidEntityDto | undefined> {
        return this.uidService.getUidEntityByUidNumberOrNull(uid);
    }

    public simplifyState(status: EnumUidStatus): string {
        switch (status) {
            case EnumUidStatus.Definitiv:
            case EnumUidStatus.InMutation:
                return 'SimpleUidStatusActive';
            default:
                return 'SimpleUidStatusInactive';
        }
    }

    public FormatUid(value: string): string {
        // Remove any non-numeric characters except 'CHE' at the start
        const cleanedValue = value.replace(/[^0-9]/g, '');

        // Ensure it matches the desired format
        if (cleanedValue.length === 9) {
            return `CHE-${cleanedValue.slice(0, 3)}.${cleanedValue.slice(3, 6)}.${cleanedValue.slice(6)}`;
        }
        return value; // Return the value unchanged if it doesn't match the criteria
    }
}
